import { render } from "./Pengajuan.vue?vue&type=template&id=6c389c86"
import script from "./Pengajuan.vue?vue&type=script&lang=js"
export * from "./Pengajuan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__